import styled from 'styled-components';

const TabsWrapper = styled.div`
  display: flex;
  width: 100%;

  border-bottom: 1px solid #a6a6a6;
`;

const Tab = styled.button<{ active?: boolean }>`
  position: relative;

  background: none;
  border: none;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding: 16px;

  ::after {
    content: '';
    display: ${({active}) => (active ? 'block' : 'none')};

    position: absolute;

    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;

    background: #2f70bc;
  }
`;

const VehicleInfo = styled.div`
  padding: 8px;

  p {
    color: #a6a6a6;
    margin: 0 0 6px;
  }
`;

const CamerasList = styled.div`
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
`;

const CameraItem = styled.div`
  position: relative;

  display: flex;
  align-items: flex-end;

  width: calc(25% - 6px);
  height: calc(25vw - 16px);
  margin-right: 8px;
  margin-bottom: 8px;
  padding-left: 4px;
  padding-bottom: 1px;

  background: #222222;

  color: #ffffff;
  font-size: 16px;
  font-weight: bold;

  :nth-child(4n) {
    margin-right: 0;
  }

  ::after {
    position: absolute;

    content: '';

    display: block;

    width: 8px;
    height: 8px;
    border-radius: 50%;

    left: 4px;
    top: 4px;

    background: chartreuse;
  }
`;

const PlayerWrapper = styled.div<{ hasError: boolean }>`
  position: relative;
  display: flex;
  background: #222222;
  height: 50vh;

  ::after {
    position: absolute;

    content: '';

    display: block;

    width: 8px;
    height: 8px;
    border-radius: 50%;

    left: 4px;
    top: 4px;

    background: ${({hasError}) => (hasError ? 'red' : 'chartreuse')};
  }
`;

const PlayerControls = styled.div`
  position: absolute;
  bottom: 0;

  display: flex;
  align-items: center;

  width: 100%;
  height: 32px;
  padding-left: 16px;

  background: #5f5d5b;

  color: #ffffff;

  > button {
    color: #ffffff;

    :first-of-type {
      margin-left: auto;
    }

    :hover {
      color: #ffffff;
    }
  }
`;

const VehicleInfoPanel = styled.div`
  position: fixed;
  z-index: 1;
  
  width: 100%;
  height: 100%;
  padding: 16px;
  
  background: #FFFFFF;
  
  button {
    position: absolute;
    right: 8px;
    top: 8px;
  }
`;

const PanelDataTitle = styled.div`
  color: ${({ theme }) => theme.colors.greyLight};
`;

const PanelDataString = styled.div`
  color: ${({ theme }) => theme.colors.black};
`;

export const Styled = {
  TabsWrapper,
  Tab,
  VehicleInfo,
  CamerasList,
  CameraItem,
  PlayerWrapper,
  PlayerControls,
  VehicleInfoPanel,
  PanelDataTitle,
  PanelDataString
};
